import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { FormLAGOService } from '../../../../Services/FormLAGOService';
import { IFormLAGO } from "../../../../Models/Forms/IFormLAGO";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { ILookupBase } from '../../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';

@Component({
  selector: 'LAGO',
  templateUrl: './LAGO.component.html',
  styleUrls: ['./LAGO.component.css']
})

export class FormLAGOComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _lookupService: LookupService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  formLAGODB: any = [];
  proficiencyLevel: any[];
  lookupAssessmentLevelList: ILookupBase[];
  reportParamArray: IReportParameter[];
  minTestDate: Date;
  lagoCalendarYearRange: string;
  checkedTrue: boolean = true;
  checkedFalse: boolean = false

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formLAGOService: FormLAGOService,
    iepService: IepService,
    lookupService: LookupService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._lookupService = lookupService;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }
  ngOnInit(): void {
    this.LoadFormLAGODetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
    this.minTestDate = new Date(this._myGlobals.todaysDate.getFullYear() - 5, 0, 1);
    this.lagoCalendarYearRange = (this._myGlobals.todaysDate.getFullYear() - 5).toString() + ':' + this._myGlobals.todaysDate.getFullYear().toString();
  }

  LoadFormLAGODetails(): void {
    this._formLAGOService.getFormLAGO(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormLAGO) => {
        this.formLAGODB = res
        if (this.formLAGODB.lookupELPACTestLevelIdListening != null) {
          this.formLAGODB.lookupELPACTestLevelIdListening = this.formLAGODB.lookupELPACTestLevelIdListening.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdSpeaking != null) {
          this.formLAGODB.lookupELPACTestLevelIdSpeaking = this.formLAGODB.lookupELPACTestLevelIdSpeaking.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdReading != null) {
          this.formLAGODB.lookupELPACTestLevelIdReading = this.formLAGODB.lookupELPACTestLevelIdReading.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdWriting != null) {
          this.formLAGODB.lookupELPACTestLevelIdWriting = this.formLAGODB.lookupELPACTestLevelIdWriting.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdOverall != null) {
          this.formLAGODB.lookupELPACTestLevelIdOverall = this.formLAGODB.lookupELPACTestLevelIdOverall.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdOverallOral != null) {
          this.formLAGODB.lookupELPACTestLevelIdOverallOral = this.formLAGODB.lookupELPACTestLevelIdOverallOral.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdOverallWritten != null) {
          this.formLAGODB.lookupELPACTestLevelIdOverallWritten = this.formLAGODB.lookupELPACTestLevelIdOverallWritten.toString();
        }
        if (this.formLAGODB.lookupELPACTestLevelIdOverallListening != null) {
          this.formLAGODB.lookupELPACTestLevelIdOverallListening = this.formLAGODB.lookupELPACTestLevelIdOverallListening.toString();
        }
        if (this.formLAGODB.celdtAssessmentDate != null) {
          this.formLAGODB.celdtAssessmentDate = new Date(this.formLAGODB.celdtAssessmentDate);
        }
        if (this.formLAGODB.elpacAssessmentDateMostRecent != null) {
          this.formLAGODB.elpacAssessmentDateMostRecent = new Date(this.formLAGODB.elpacAssessmentDateMostRecent);
        }
        if (this.formLAGODB.elpacAssessmentDatePrevious != null) {
          this.formLAGODB.elpacAssessmentDatePrevious = new Date(this.formLAGODB.elpacAssessmentDatePrevious);
        }
        if (this.formLAGODB.elpacAssessmentDateNextPrevious != null) {
          this.formLAGODB.elpacAssessmentDateNextPrevious = new Date(this.formLAGODB.elpacAssessmentDateNextPrevious);
        }
        if (this.formLAGODB.cstDate != null) {
          this.formLAGODB.cstDate = new Date(this.formLAGODB.cstDate);
        }
        if (this.formLAGODB.otherTestDate != null) {
          this.formLAGODB.otherTestDate = new Date(this.formLAGODB.otherTestDate);
        }
        if (this.formLAGODB.primaryLanguageTestInitialDate != null) {
          this.formLAGODB.primaryLanguageTestInitialDate = new Date(this.formLAGODB.primaryLanguageTestInitialDate);
        }
        if (this.formLAGODB.skillListeningInitialDate != null) {
          this.formLAGODB.skillListeningInitialDate = new Date(this.formLAGODB.skillListeningInitialDate);
        }
        if (this.formLAGODB.skillListeningPreviousDate != null) {
          this.formLAGODB.skillListeningPreviousDate = new Date(this.formLAGODB.skillListeningPreviousDate);
        }
        if (this.formLAGODB.skillListeningPreviousDate2 != null) {
          this.formLAGODB.skillListeningPreviousDate2 = new Date(this.formLAGODB.skillListeningPreviousDate2);
        }
        if (this.formLAGODB.skillOverallInitialDate != null) {
          this.formLAGODB.skillOverallInitialDate = new Date(this.formLAGODB.skillOverallInitialDate);
        }
        if (this.formLAGODB.skillOverallPreviousDate != null) {
          this.formLAGODB.skillOverallPreviousDate = new Date(this.formLAGODB.skillOverallPreviousDate);
        }
        if (this.formLAGODB.skillOverallPreviousDate2 != null) {
          this.formLAGODB.skillOverallPreviousDate2 = new Date(this.formLAGODB.skillOverallPreviousDate2);
        }
        if (this.formLAGODB.skillReadingInitialDate != null) {
          this.formLAGODB.skillReadingInitialDate = new Date(this.formLAGODB.skillReadingInitialDate);
        }
        if (this.formLAGODB.skillReadingPreviousDate2 != null) {
          this.formLAGODB.skillReadingPreviousDate2 = new Date(this.formLAGODB.skillReadingPreviousDate2);
        }
        if (this.formLAGODB.skillSpeakingInitialDate != null) {
          this.formLAGODB.skillSpeakingInitialDate = new Date(this.formLAGODB.skillSpeakingInitialDate);
        }
        if (this.formLAGODB.skillSpeakingPreviousDate != null) {
          this.formLAGODB.skillSpeakingPreviousDate = new Date(this.formLAGODB.skillSpeakingPreviousDate);
        }
        if (this.formLAGODB.skillSpeakingPreviousDate2 != null) {
          this.formLAGODB.skillSpeakingPreviousDate2 = new Date(this.formLAGODB.skillSpeakingPreviousDate2);
        }
        if (this.formLAGODB.skillWritingInitialDate != null) {
          this.formLAGODB.skillWritingInitialDate = new Date(this.formLAGODB.skillWritingInitialDate);
        }
        if (this.formLAGODB.skillWritingPreviousDate != null) {
          this.formLAGODB.skillWritingPreviousDate = new Date(this.formLAGODB.skillWritingPreviousDate);
        }
        if (this.formLAGODB.skillWritingPreviousDate2 != null) {
          this.formLAGODB.skillWritingPreviousDate2 = new Date(this.formLAGODB.skillWritingPreviousDate2);
        }
        if (this.formLAGODB.reclassificationMeetingDate != null) {
          this.formLAGODB.reclassificationMeetingDate = new Date(this.formLAGODB.reclassificationMeetingDate);
        }
      },
        err => console.error(err)
      );
  }

  LoadLookupValues() {
    this.proficiencyLevel = [
      { value: "[Select One]", label: "[Select One]" },
      { value: 1, label: "1-8" },
      { value: 2, label: "9-12" }
    ];

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AssessmentLevel]).subscribe((res: ILookupBase[]) => {
      this.lookupAssessmentLevelList = res;
    },
      err => console.error(err)
    );


  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }


  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the IndividualizedTransitionPlan
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;
    this.showSpinner = true;

    //update values
    this.timeStamp = new Date();
    this._formLAGOService.insertUpdateFormLAGO(this.formLAGODB)
      .subscribe((res: IFormLAGO) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.showSpinner = false;
        this.LoadFormLAGODetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
          this.showSpinner = false;
        }
      )
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormLAGODetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formLAGODB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'True' : 'False'  },
      { parameterName: 'FormInstanceID', parameterValue: this.formLAGODB._IepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: this._myGlobals.selectedDashboardDocument.status == 'Draft' ? 'true' : 'false' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'IEPID', parameterValue: null },
      { parameterName: 'BlankForm', parameterValue: 'false' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formLAGODB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formLAGODB.rdlFileNameSpanish, this.reportParamArray);
  }

}
